<template>
  <v-card class="card-wrap">
    <v-card color="grey" flat height="50px" class="topbar">
      <v-toolbar color="white" prominent height="50px">
        <NotificationButtons
          :unreadRequestNotificationCount="unreadRequestNotificationCount"
          :unreadSystemNotificationCount="unreadSystemNotificationCount"
          :color="color"
          :disabled="loading"
          :isHideRevenue="isHideRevenue"
          @onClickSystem="onClickSystem"
          @onClickRequest="onClickRequest"
          style="width: 100%;"
        />
        <v-spacer />
        <NotificationSettings :isHideRevenue="isHideRevenue" />
      </v-toolbar>
    </v-card>
    <div class="notificationList">
      <NotificationList
        v-if="hasNotificationList"
        :notificationList="notificationList"
        :isNotificationTopPage="true"
        :loading="loading"
        @fetchUnreadNotificationsCount="fetchUnreadNotificationsCount"
      />
      <AppForm
        v-else
        class="empty-notification"
        label="新しいお知らせはありません。"
      />
    </div>
    <v-card class="bottombar">
      <v-layout justify-space-between align-center fill-height>
        <v-flex xs4 align-center justify-content-start>
          <NotificationReadAllButton
            :unreadNotificationList="notificationList"
            :loading="loading"
            @fetchUnreadNotificationsCount="fetchUnreadNotificationsCount"
          />
        </v-flex>
        <v-flex align-center justify-content-center>
          <NotificationInformation
            :unreadSystemNotificationCount="unreadSystemNotificationCount"
            :unreadRequestNotificationCount="unreadRequestNotificationCount"
            :isHideRevenue="isHideRevenue"
            @fetchUnreadNotificationsCount="fetchUnreadNotificationsCount"
          />
        </v-flex>
        <v-flex
          xs4
          class="d-flex align-center justify-center"
          style="text-align: center;"
        >
          <v-icon @click="openHelpPage()" color="primary"
            >mdi-help-circle</v-icon
          >
          <span
            @click="openHelpPage()"
            style="font-size: 13px; cursor: pointer; color: #007bff; text-decoration:underline;"
          >
            通知センターヘルプ
          </span>
        </v-flex>
      </v-layout>
    </v-card>
  </v-card>
</template>

<script>
import { NotificationRepository } from '@/models/Notification'
import NotificationSettings from './NotificationSettings'
import NotificationReadAllButton from './NotificationReadAllButton'
import NotificationList from './NotificationList'
import NotificationInformation from './NotificationInformation'
import NotificationButtons from './NotificationButtons'
import { NotificationType } from '@/models/Notification/Constants'

const defaultColor = '#DDDDDD'
const selectedButtonUnclickable = '#5D99FF'

export default {
  name: 'NotificationTopPage',
  components: {
    NotificationSettings,
    NotificationList,
    NotificationInformation,
    NotificationButtons,
    NotificationReadAllButton,
  },
  props: {
    unreadRequestNotificationCount: {
      type: Number,
      default: 0,
    },
    unreadSystemNotificationCount: {
      type: Number,
      default: 0,
    },
    isHideRevenue: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      isSystemNotification: false,
      isRequestNotification: false,
      notificationList: [],
      color: {
        system: defaultColor,
        request: defaultColor,
      },
      loading: false,
    }
  },
  computed: {
    hasNotificationList() {
      if (this.isSystemNotification) return this.hasSystemNotification
      if (this.isRequestNotification) return this.hasRequestNotification
      return false
    },
    hasSystemNotification() {
      return this.unreadSystemNotificationCount > 0
    },
    hasRequestNotification() {
      return this.unreadRequestNotificationCount > 0
    },
    notificationType() {
      if (this.isSystemNotification) return NotificationType.system
      if (this.isRequestNotification) return NotificationType.request
      return ''
    },
  },
  watch: {
    async isSystemNotification(val) {
      if (!this.hasSystemNotification) {
        this.color.system = val ? selectedButtonUnclickable : defaultColor
        return
      }
      this.color.system = val ? 'primary' : defaultColor
      if (val) await this.fetchUnreadNotificationList()
    },
    async isRequestNotification(val) {
      if (!this.hasRequestNotification) {
        this.color.request = val ? selectedButtonUnclickable : defaultColor
        return
      }
      this.color.request = val ? 'primary' : defaultColor
      if (val) await this.fetchUnreadNotificationList()
    },
  },
  created() {
    this.isRequestNotification = true
  },
  methods: {
    onClickSystem(...args) {
      const [isSystemClicked, isRequestClicked] = args
      this.isSystemNotification = isSystemClicked
      this.isRequestNotification = isRequestClicked
    },
    onClickRequest(...args) {
      const [isRequestClicked, isSystemClicked] = args
      this.isSystemNotification = isSystemClicked
      this.isRequestNotification = isRequestClicked
    },
    async fetchUnreadNotificationList() {
      this.loading = true
      this.notificationList = await NotificationRepository.getAllNotificationsByIsRead(
        this.notificationType,
        false,
      )
      this.loading = false
    },
    fetchUnreadNotificationsCount() {
      this.$emit('fetchUnreadNotificationsCount')
    },
    openHelpPage() {
      window.open(
        'https://go.geologic.co.jp/adminmanual_admin_notice',
        '_blank',
        'noreferrer',
      )
    },
  },
}
</script>

<style scoped lang="scss">
.card-wrap {
  width: 32vw;
  min-width: 320px;
  max-width: 600px;
  height: 300px;
  min-height: 240px;
  max-height: 500px;
  overflow: hidden;
}

.notificationList {
  width: 100%;
  height: calc(100% - 50px - 56px);
  overflow-x: hidden;
  overflow-y: scroll;
}

.empty-notification {
  margin-left: 120px;
  margin-top: 80px;
}

.topbar {
  width: 100%;
  top: 0;
  overflow: hidden;
}

.bottombar {
  background-color: white;
  bottom: 0;
  height: 56px;
  padding: 8px;
}

.bottom-button2 {
  color: blue;
}
</style>
